import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "@/lib/api";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const [orgs, setOrgs] = useState([]);
  const [active, setActive] = useState(() => localStorage.getItem("dv_workspace") || "personal");

  const refreshOrgs = useCallback(async () => {
    try { const { data } = await api.get("/orgs"); setOrgs(data); return data; }
    catch { setOrgs([]); return []; }
  }, []);

  useEffect(() => { refreshOrgs(); }, [refreshOrgs]);

  const setWorkspace = useCallback((w) => {
    setActive(w);
    localStorage.setItem("dv_workspace", w);
  }, []);

  // If the active org disappears (left/removed/deleted), fall back to personal.
  useEffect(() => {
    if (active !== "personal" && orgs.length > 0 && orgs.every((o) => o.org_id !== active)) {
      setActive("personal");
      localStorage.setItem("dv_workspace", "personal");
    }
  }, [orgs, active]);

  const activeOrg = active === "personal" ? null : orgs.find((o) => o.org_id === active) || null;
  const orgId = activeOrg ? activeOrg.org_id : null;

  const value = useMemo(
    () => ({ orgs, active, activeOrg, orgId, setWorkspace, refreshOrgs }),
    [orgs, active, activeOrg, orgId, setWorkspace, refreshOrgs]
  );

  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export const useWorkspace = () => useContext(WorkspaceContext);
